import script from "./HrProviderBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HrProviderBtn.vue?vue&type=script&setup=true&lang=js"

import "./HrProviderBtn.vue?vue&type=style&index=0&id=2af0f9a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af0f9a7"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
